/** Strip non-digits and validate 12-digit Aadhar */
export const normalizeAadhar = (value: string): string =>
  String(value || "").replace(/\D/g, "").slice(0, 12);

/** Mask for display: XXXX-XXXX-1234 */
export const maskAadhar = (value?: string | null): string => {
  const digits = normalizeAadhar(value || "");
  if (digits.length !== 12) return "—";
  return `XXXX-XXXX-${digits.slice(-4)}`;
};

/** Format while typing: 1234 5678 9012 */
export const formatAadharDisplay = (value: string): string => {
  const d = normalizeAadhar(value);
  if (d.length <= 4) return d;
  if (d.length <= 8) return `${d.slice(0, 4)} ${d.slice(4)}`;
  return `${d.slice(0, 4)} ${d.slice(4, 8)} ${d.slice(8)}`;
};
